import { render, staticRenderFns } from "./SlideFilter.vue?vue&type=template&id=6c2fa4d2&scoped=true&"
import script from "./SlideFilter.vue?vue&type=script&lang=js&"
export * from "./SlideFilter.vue?vue&type=script&lang=js&"
import style0 from "./SlideFilter.vue?vue&type=style&index=0&id=6c2fa4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2fa4d2",
  null
  
)

export default component.exports